import type { ReferenceLineDirection } from '@/version-types';

type Keys = 'HORIZONTAL' | 'VERTICAL';

export const REFERENCE_LINE_DIRECTION: Record<Keys, ReferenceLineDirection> = {
    HORIZONTAL: 'horizontal',
    VERTICAL: 'vertical',
};

export const REFERENCE_LINE_EVENT_NAMES = {
    HIGHLIGHT: 'highlight-reference-lines',
    SYNC: 'sync-reference-lines',
    REQUEST_SYNC: 'request-sync-reference-lines',
    SYNC_STAGE_RESIZE_START: 'sync-stage-resize-start',
    SYNC_STAGE_RESIZE_END: 'sync-stage-resize-end',
    SYNC_STAGE_RESIZING: 'sync-stage-resizing',
};
